import React from 'react'
import Card from '@components/V3/Card'
import Pill from '@components/V3/Pill'
import classnames from '@helpers/misc/classnames'
import useScreenSize from '@hooks/useScreenSize'
import {useTranslation} from 'next-i18next'

import useCheckoutErrorContext from '../hooks/useCheckoutErrorContext'

export interface Props {
  icon?: React.ReactNode
  children: React.ReactNode
  onClick?: () => void
  compact?: boolean
  smallPill?: boolean
  transparentOnDesktop?: boolean
  caretDirection?: 'up' | 'down'
  subsection?: React.ReactNode
  pillText?: string
  noPill?: boolean
  className?: string
  id?: string
  pillClassName?: string
  pillStylePrimary?: boolean
}

export default function Section({
  icon,
  children,
  onClick = () => {},
  compact,
  noPill = false,
  smallPill,
  transparentOnDesktop,
  caretDirection,
  subsection,
  pillText,
  className = '',
  id,
  pillClassName = '',
  pillStylePrimary = false
}: Props) {
  const {t} = useTranslation('generic')
  const screenSize = useScreenSize()
  const {showAnimation: showErrorAnimation, error} = useCheckoutErrorContext(id)
  return (
    <Card
      id={id}
      transparentOnDesktop={transparentOnDesktop}
      mobileStyle={compact ? 'compact' : 'default'}
      className={classnames({
        'max-w-[1024px] w-full transition ease-in-out duration-150': true,
        [className]: true,
        'text-red-500': showErrorAnimation
      })}>
      <div className="px-4 flex items-center cursor-pointer relative" onClick={onClick}>
        {icon ? <div className="mr-2 flex items-center">{icon}</div> : null}
        <div className="flex-1 pr-1">
          {children}
          <span
            className={classnames({
              'flex h-3 w-3 absolute top-0 left-2 transition ease-in-out duration-150': true,
              'opacity-0': !showErrorAnimation
            })}>
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
          </span>
        </div>
        {noPill ? null : !pillText && (screenSize === 'mobile' || !!smallPill) ? (
          <Pill square caretDirection={caretDirection} />
        ) : (
          <Pill
            caretDirection={caretDirection}
            primary={pillStylePrimary}
            className={classnames({'pl-3 pr-1 text-xs ': true, [pillClassName]: true})}>
            {pillText ? pillText : t('fields.edit')}
          </Pill>
        )}
      </div>
      {subsection && <div className="px-4">{subsection}</div>}
    </Card>
  )
}
